import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const BUYER_SETTINGS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('BUYER_SETTINGS');
export const BUYER_SETTINGS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	BUYER_SETTINGS_CRUD_ACTION_CONSTANTS
);
